module.exports = __webpack_public_path__ + "img/member.02261d08.png";